import React, {useState, useEffect} from 'react';
import {Col, Row} from 'react-bootstrap';
import LVComponent from './LVComponent';
import AnnotationComponent from './AnnotationComponent';
import AnnotatorFooter from './AnnotatorFooter';
//import {getCurrentAnalyse} from "../../API/annotatorApi";



const lvComponentStyle = {
	marginRight: 0,
	height: 925
};

const annotationComponentStyle = {
	marginLeft: -16,
	height: 925
};

const annotationFooterStyle = {
	marginLeft: 15, marginRight: 15
};

function AnnotatorComponent(props) {
    const [analyse, setAnnotationData] = useState(props.annotationData);
    const [component, setComponent] = useState(<></>);
    useEffect(() => {
        const annotatorView = <div>
            <br/>
            <Row>
                {(props.lvComponentShow === true && props.annotationComponentShow === true) && <>
                    <Col className="col-9" style={lvComponentStyle}>
                        <LVComponent
                            lvreportDisplay={props.lvreportDisplay}
                            lvstatus={props.lvstatus}
                            lvList={props.lvList}
                            annotationData={analyse}
							setAnnotationData={setAnnotationData}
                            adviceList={props.adviceList}
                            lvCustomerView={props.lvCustomerView}
                            positionCategoryShow={props.positionCategoryShow}
                            suggestComponentShow={props.suggestComponentShow}
                            highlightPossible={props.highlightPossible}
                        />
                    </Col>
                    <Col className="col-3 handwai-dark div-border" style={annotationComponentStyle}>
                        <AnnotationComponent
                            lvreportDisplay={props.lvreportDisplay}
                            lvid={props.lvList.parsedlv_id}
                            advicelist={props.adviceList}
                            lvstatus={props.lvstatus}
                            annotationData={analyse}
							setAnnotationData={setAnnotationData}
                            searchComponentShow={props.searchComponentShow}
                            deleteComponentShow={props.deleteComponentShow}
                            summaryComponentShow={props.summaryComponentShow}
                            saveComponentShow={props.saveComponentShow}
                            annotationCustomerView={props.annotationCustomerView}
                        />
                    </Col>
				</>}
                {props.lvComponentShow === true && props.annotationComponentShow === false ? <>
                    <Col style={lvComponentStyle}>
                        <LVComponent
                            lvreportDisplay={props.lvreportDisplay}
                            lvstatus={props.lvstatus}
                            lvList={props.lvList}
                            adviceList={props.adviceList}
							annotationData={analyse}
							setAnnotationData={setAnnotationData}
                            positionCategoryShow={props.positionCategoryShow}
                            suggestComponentShow={props.suggestComponentShow}
                            highlightPossible={props.highlightPossible}
                        />
                    </Col>
				</> : ''}
                {props.lvComponentShow === false && props.annotationComponentShow === true ? <>
                    <Col className="handwai-dark div-border">
                        <AnnotationComponent
                            lvreportDisplay={props.lvreportDisplay}
                            lvid={props.lvList.parsedlv_id}
                            advicelist={props.adviceList}
                            lvstatus={props.lvstatus}
							annotationData={analyse}
							setAnnotationData={setAnnotationData}
                            searchComponentShow={props.searchComponentShow}
                            deleteComponentShow={props.deleteComponentShow}
                            summaryComponentShow={props.summaryComponentShow}
                            saveComponentShow={props.saveComponentShow}
                            annotationCustomerView={props.annotationCustomerView}
                        />
                    </Col>
				</> : ''}
            </Row>
            {props.annotatorFooterShow === true && <Row>
                <Col className="handwai-dark div-border" style={annotationFooterStyle}>
                    <AnnotatorFooter
                        lvid={props.lvList.parsedlv_id}
                        lvstatus={props.lvstatus}
                        links={props.links}
                        projectFirm={props.projectFirm}
                        annotationData={analyse}
                        setAnnotationData={setAnnotationData}
                        publishComponentShow={props.publishComponentShow}
                        editAdviceComponentShow={props.editAdviceComponentShow}
                        ignoreComponentShow={props.ignoreComponentShow}
                        categoryComponentShow={props.categoryComponentShow}
                        createAdviceComponentShow={props.createAdviceComponentShow}
                        projectuploader={props.projectuploader}
                    />
                </Col>
            </Row>}
        </div>
        setComponent(annotatorView)

    }, [])

        return (component);

}

export default AnnotatorComponent;
